import {
  Badge,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  CRUD_LABELS,
  CRUD_MODELS,
  HEADERS,
  SCIENTIFIC_RESEARCH_CONSTANTS,
} from "../../../constants";
import CrudTable from "../../../components/Crud/CrudTable/CrudTable";
import { journalDomesticActions, userActions } from "../../../actions";
import DuyetThanhTichModal from "../DuyetThanhTichModal";
import ThanhTichInsert from "../../DangKyHoSo/ThanhTichInsert";
import {
  apiCall,
  autoScore,
  downloadFile,
  fileRender,
  toPlural,
} from "../../../utils";
import { Close, Download } from "@mui/icons-material";
import { defaultRows } from "../../../constants/scoringInformation.constants";

const OPTIONS = [
  ...SCIENTIFIC_RESEARCH_CONSTANTS.FILTER_TYPE,
  {
    key: CRUD_MODELS.MONOGRAPH,
    value: CRUD_MODELS.MONOGRAPH,
    title: CRUD_LABELS[CRUD_MODELS.MONOGRAPH],
  },
];

function DanhSachThanhTichTable(props) {
  const dispatch = useDispatch();

  const { id } = props?.id || useParams();
  const { formReducer } = useSelector((state) => state);

  const journalDomestics = useSelector(
    (state) => state.journalDomesticReducer.list
  );

  // const [type, setType] = useState(CRUD_MODELS.SCIENTIFIC_RESEARCH);
  // const [dialog, setDialog] = useState(null);
  // const [srFilterType, setSrFilterType] = useState(
  //   SCIENTIFIC_RESEARCH_CONSTANTS.FILTER_TYPE[0].key
  // );
  // const [duyetThanhTich, setDuyetThanhTich] = useState(false);

  const handleReload = () => {
    dispatch(
      journalDomesticActions.filterJournalDomestic({
        page: 1,
        pageSize: 10000,
        percent: 0,
        title: "",
      })
    );
  };

  // const exportFile = async (endPoint) => {
  //   dispatch(userActions.setLoadingGlobal(true));

  //   const { response, error } = await apiCall({
  //     endPoint: "/api/v1/export" + endPoint,
  //     method: "GET",
  //     headers: HEADERS.DEFAULT_HEADER,
  //   });

  //   if (!error && response.status === 200) {
  //     downloadFile(fileRender(response.data.data));
  //   } else {
  //     dispatch(
  //       userActions.notification({
  //         message: "Xuất dữ liệu thất bại",
  //         type: "error",
  //       })
  //     );
  //   }

  //   dispatch(userActions.setLoadingGlobal(false));
  // };

  const scoreInfos = useMemo(() => {
    return [
      ...defaultRows,
      ...journalDomestics.map((journal) => ({
        ...journal,
        journalDomesticId: journal.id,
        type: CRUD_MODELS.SCIENTIFIC_RESEARCH,
        description: `${journal.title} (${journal.publisher})`,
      })),
    ];
  }, [defaultRows, journalDomestics]);

  // useEffect(() => {
  //   if (formReducer.scientificResearchs.length > 0) {
  //     formReducer.scientificResearchs.forEach((ctkh) => {
  //       const data = { ...ctkh };
  //       const found = autoScore("scientificResearch", data, scoreInfos);
  //       const accur = JSON.parse(
  //         formReducer.form.researchSummary
  //       ).scientificResearchs.find((e) => e.id === ctkh.id);
  //       if ((found.maxPoint || 0) !== (accur?.maxPoint || 0)) {
  //         // console.log(data.orderNumber, ctkh.filterType, data.title, found.maxPoint, accur?.maxPoint);
  //       }
  //     });

  //     formReducer.monographs.forEach((ctkh) => {
  //       const data = { ...ctkh };
  //       const found = autoScore("monograph", data, scoreInfos);
  //       const accur = JSON.parse(
  //         formReducer.form.researchSummary
  //       ).monographs.find((e) => e.id === ctkh.id);
  //       if ((found.maxPoint || 0) !== (accur?.maxPoint || 0)) {
  //         // console.log(data.orderNumber, 'monograph', data.title, found.maxPoint, accur?.maxPoint);
  //       }
  //     });
  //   }
  // }, [formReducer]);

  // const unAcceptedCounter = useMemo(() => {
  //   const res = {};
  //   OPTIONS.forEach((option) => {
  //     var rows;
  //     if (formReducer.hasOwnProperty(toPlural(option.key)))
  //       rows = formReducer[toPlural(option.key)];
  //     else
  //       rows = formReducer.scientificResearchs.filter(
  //         (e) => e.filterType === option.key
  //       );
  //     rows = rows || [];
  //     res[option.key] = rows.filter((e) => !e?.scoringTable?.accepted)?.length;
  //   });
  //   return res;
  // }, [formReducer]);

  useEffect(() => {
    handleReload();
  }, []);

  const handleClose = () => {
    props.handleClose();
  };

  // for tat ca type trong options
  // Voi moi type lay ra data = formReducer?.[toPlural(type)]
  // voi moi du lieu tinh ra diem
  // neu co diem thi lay ra maxPoint

  const calPoint = (type, data) => {
    if (!type || !data || !scoreInfos) return;
    const found = autoScore(type, data, scoreInfos);
    return found;
  };
  // console.log(formReducer.scientificResearchs, 'formReducer.scientificResearchs');

  const allOptionPoints = useMemo(() => {
    const res = {};
    OPTIONS.forEach((option) => {
      var rows;
      if (formReducer.hasOwnProperty(toPlural(option.key)))
        rows = formReducer[toPlural(option.key)];
      else
        rows = formReducer.scientificResearchs.filter(
          (e) => e.filterType === option.key
        );
      rows = rows || [];
      let _type = option.key;
      if (_type !== CRUD_MODELS.MONOGRAPH) {
        _type = CRUD_MODELS.SCIENTIFIC_RESEARCH;
      }
      res[option.key] = rows.map((e) => calPoint(_type, e));
    });
    return res;
  }, [formReducer]);
  // console.log(allOptionPoints);

  // trong moi option cua allOptionPoints can lay ra theo dinh dang {title, maxPointAfter, maxPointBefore}
  // title = OPTIONS[key].title
  // maxPointAfter = maxPoint cua cac item co data.phase = 'after'
  // maxPointBefore = maxPoint cua cac item co data.phase = 'before'

  const allOptionPointsData = useMemo(() => {
    const res = {};
    // for key, value in allOptionPoints
    Object.keys(allOptionPoints).forEach((key) => {
      const data = allOptionPoints[key];
      const title = OPTIONS.find((item) => item.key === key)?.title;
      // console.log(data);
      // if (key == "conference") {
      //   console.log("data", data);
      // }
      const maxPointAfter = data
        .filter((item) => item?.data?.phase === "after")
        .reduce(
          (acc, item) =>
            acc + (item?.point && isFinite(item?.point) ? item?.point : 0),
          0
        );
      const maxPointBefore = data
        .filter((item) => item?.data?.phase === "before")
        .reduce(
          (acc, item) =>
            acc + (item?.point && isFinite(item?.point) ? item?.point : 0),
          0
        );
      // to fix 2 after comma
      const maxPointAfterFixed = Math.round(maxPointAfter * 100) / 100;
      const maxPointBeforeFixed = Math.round(maxPointBefore * 100) / 100;
      res[key] = {
        title,
        maxPointAfterFixed,
        maxPointBeforeFixed,
      };
    });
    return res;
  }, [allOptionPoints]);
  // console.log(allOptionPointsData);

  return (
    <Dialog
      fullWidth
      // maxWidth={
      //   dialog?.filterType === "international" && isChamDiemScene ? "lg" : "sm"
      // }
      maxWidth="md"
      open={props.dialog?.open}
      onClose={handleClose}
      scroll="paper"
    >
      <DialogTitle style={{ padding: "4px 12px 4px 24px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5">Tính điểm</Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {/* Hiển thị allOptionPointsData theo từng hàng */}
        <Grid container spacing={2} sx={{ padding: 2 }}>
          <Grid
            item
            xs={12}
            sm={8}
            md={8}
            container
            spacing={1}
            sx={{ padding: 1 }}
          >
            {Object.keys(allOptionPointsData).map((key) => {
              const data = allOptionPointsData[key];
              // console.log("data", key, data);
              return (
                <Grid item xs={12} sm={12} md={12} key={key}>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "16px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <Typography variant="h6">{data.title}</Typography>
                    <Typography variant="body1">
                      Điểm tối đa trước TS/PGS: {data.maxPointBeforeFixed}
                    </Typography>
                    <Typography variant="body1">
                      Điểm tối đa sau TS/PGS: {data.maxPointAfterFixed}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
          {/* Hiển thị tổng điểm trước/sau TS/PGS của tất cả các hạng mục */}
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            container
            spacing={1}
            sx={{ padding: 1 }}
          >
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                alignContent: "center",
              }}
            >
              <Typography variant="h6" style={{ textAlign: "center" }}>
                Tổng điểm
              </Typography>
              <Typography variant="body1">
                Tổng điểm trước TS/PGS:{" "}
                {Object.values(allOptionPointsData)
                  .reduce((acc, item) => acc + item.maxPointBeforeFixed, 0)
                  .toFixed(2)}
              </Typography>
              <Typography variant="body1">
                Tổng điểm sau TS/PGS:{" "}
                {Object.values(allOptionPointsData)
                  .reduce((acc, item) => acc + item.maxPointAfterFixed, 0)
                  .toFixed(2)}
              </Typography>
              <Typography variant="body1">
                Tổng điểm:{" "}
                {(
                  Object.values(allOptionPointsData).reduce(
                    (acc, item) => acc + item.maxPointAfterFixed,
                    0
                  ) +
                  Object.values(allOptionPointsData).reduce(
                    (acc, item) => acc + item.maxPointBeforeFixed,
                    0
                  )
                ).toFixed(2)}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      {/* <Fragment>
        <Box p={1} sx={{ display: "flex", justifyContent: "space-between" }}>
        <FormControl sx={{ m: 1, width: 512 }}>
        <InputLabel id="select-id">Chọn thành tích</InputLabel>
        <Select
              id="select-id"
              size="small"
              label="Chọn thành tích"
              value={
                type === CRUD_MODELS.SCIENTIFIC_RESEARCH ? srFilterType : type
              }
              onChange={(e) => {
                const value = e.target.value;
                if (
                  SCIENTIFIC_RESEARCH_CONSTANTS.FILTER_TYPE.find(
                    (item) => item.key === value
                  )
                ) {
                  // Thuộc bài báo
                  setType(CRUD_MODELS.SCIENTIFIC_RESEARCH);
                  setSrFilterType(value);
                } else {
                  setType(value);
                }
              }}
            >
              {OPTIONS.map((type) => (
                <MenuItem key={type.key} value={type.key}>
                  <Badge
                    className="srBadge"
                    color="secondary"
                    badgeContent={unAcceptedCounter?.[type.key]}
                  >
                    {type.title}
                  </Badge>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            size="small"
            color="primary"
            sx={{ my: 1 }}
            onClick={() => exportFile("/6a9/" + id)}
            startIcon={<Download />}
          >
            Xuất file 6A9
          </Button>
        </Box>
        <CrudTable
          type={type}
          setDialog={setDialog}
          rows={formReducer?.[toPlural(type)]}
          filterType={srFilterType}
          setDuyetThanhTich={setDuyetThanhTich}
        />
        <ThanhTichInsert dialog={dialog} setDialog={setDialog} />
        <DuyetThanhTichModal
          type={type}
          data={duyetThanhTich}
          setDuyetThanhTich={setDuyetThanhTich}
        />
      </Fragment> */}
    </Dialog>
  );
}

export default DanhSachThanhTichTable;
